import React from 'react';
import profile from '../../../images/profile1.png'
import Typical from 'react-typical';
import '../../../App.css';

const Banner = () => {
    return (
        <>
            <div class="cursor-1"></div>
            <div class="cursor-2"></div>
            <div className="banner-bg mt-5 pt-5">
                <div className="container">
                    <div className="d-flex flex-column flex-lg-row justify-content-center align-items-center">
                        <div className="col-lg-6 col-12 text-start p-lg-0 p-4">
                            <h2 className="text-light text-size">Hey I'm Imam</h2>
                            <h2 className="text-light text-size">Hassan Rimon</h2>
                            <Typical className="text-light fw-bold mt-3 mb-4" steps={['I\'m Front End developer.', 1000, 'I\'m React Developer.', 2500]}
                                loop={Infinity}
                                wrapper="h2"
                                color="white"
                            />
                            <br />
                            <a target="_blank" rel="noreferrer" href="https://drive.google.com/uc?export=download&id=1PhU3bSSfaPaHWbAGVLDPvel-C0SGFyIe"><button className="btn btn-bg text-light px-3 rounded-pill">Download Resume</button></a>
                        </div>
                        <div className="col-lg-6 col-12">
                            <img src={profile} className="w-100 p-5" alt="" />
                        </div>
                    </div>
                </div>
            </div >
        </>

    );
};

export default Banner;